document.addEventListener("DOMContentLoaded", function () {
  const loadMoreBtn = document.getElementById("loadMore");
  if (!loadMoreBtn) return;

  loadMoreBtn.addEventListener("click", function () {
    const page = parseInt(loadMoreBtn.dataset.page);
    const max = parseInt(loadMoreBtn.dataset.max);
    const url = window.location.pathname + `?page=${page}`;

    fetch(url)
      .then(response => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newProducts = doc.querySelector('#product-grid');
        if (newProducts) {
          document.getElementById('product-grid').insertAdjacentHTML('beforeend', newProducts.innerHTML);
        }

        if (page >= max) {
          loadMoreBtn.remove();
        } else {
          loadMoreBtn.dataset.page = page + 1;
        }
      })
      .catch(err => {
        console.error("Errore nel caricamento dei prodotti:", err);
      });
  });
});
